import { Injectable } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { isNullOrUndefined } from '@pineapplelab/util';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor(private fireStorage: AngularFireStorage) {}

  uploadFile(path: string, file: File, metadata?: firebase.default.storage.UploadMetadata) {
    if (isNullOrUndefined(metadata)) {
      metadata = { contentType: file.type };
    }
    return this.fireStorage.upload(path, file, metadata).then((r) => r.ref.getDownloadURL());
  }
}
